var t=Math.ceil,n=Math.floor,c=Math.trunc||function(a){var r=+a;return(r>0?n:t)(r)};export{c as default};
